import React, { useEffect, useState } from "react";
import classes from "./BadgeList.module.scss";
import Header from "../../molecules/header/Header";
import { fetchUser, User } from "../../api/UsersApi";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { useNavigate } from "react-router-dom";
import { fetchUsersBadge } from "../../api/UsersBadgeApi";
import BadgeCard from "../../organism/badge-card/BadgeCard";
import greenBadge from "../../static/images/greenBadge.png";
import rainbowBadge from "../../static/images/rainbowBadge.png";
import yellowBadge from "../../static/images/yellowBadge.png";
import TeacherComment from "../../molecules/teacher-commnet/TeacherComment";
import CharComment from "../../static/images/charComment.png";

const BadgeList = () => {
  const badgeApi = fetchUsersBadge();
  const navigate = useNavigate();

  const [user, setUser] = useState<User | null>(null);
  const fetchUserApi = fetchUser();

  // バッジ数（undefinedは0扱い）
  const rainbow = user?.numberOfCompletedRainbowbadge ?? 0;
  const gold    = user?.numberOfCompletedGoldbadge ?? 0;
  const green   = user?.numberOfCompletedGreenbadge ?? 0;

  // 表示条件
  const hasAnyBadge = rainbow > 0 || gold > 0 || green > 0;
  const allZero     = rainbow === 0 && gold === 0 && green === 0;

  useEffect(() => {
    fetchUserApi.fetch();
    badgeApi.fetch({ isCompleted: true });
  }, []);

  useEffect(() => {
    if (fetchUserApi.state?.data == null) return;
    setUser(fetchUserApi.state.data[0]);
  }, [fetchUserApi.state?.data]);

  return (
    <>
      <div className={classes.container}>
        <Header />
        <div className={classes.title}>バッジリスト</div>

        {/* どれかが1つでも > 0 のときだけ表示 */}
        {hasAnyBadge && (
          <div className={classes.badgeArea}>
            <div className={classes.badgeCircle}>
              <img src={rainbowBadge} alt="badge" className={classes.badgeImg} />
              <div className={classes.inCircle} style={{ backgroundColor: "#FFF7D4" }}>
                {rainbow}
              </div>
            </div>

            <div className={classes.badgeCircle}>
              <img src={yellowBadge} alt="badge" className={classes.badgeImg} />
              <div className={classes.inCircle} style={{ backgroundColor: "#FFF7D4" }}>
                {gold}
              </div>
            </div>

            <div className={classes.badgeCircle}>
              <img src={greenBadge} alt="badge" className={classes.badgeImg} />
              <div className={classes.inCircle} style={{ backgroundColor: "#E1F8F3" }}>
                {green}
              </div>
            </div>
          </div>
        )}

        <div className={classes.button}>
          <SimpleButton
            label="クイズ一覧に戻る"
            width="50%"
            color="orange"
            isRadius={true}
            onClick={() => navigate("/quiz")}
          />
        </div>

        {/* 3つとも 0 のときだけ表示 */}
        {allZero && (
          <div className={classes.comment}>
            <TeacherComment
              image={CharComment}
              bgWhite={true}
              charRight={true}
              comment={[
                "◯×クイズを実施すると",
                "バッジをゲットできます♪",
              ]}
            />
          </div>
        )}

        <div className={classes.badgeContents}>
          {badgeApi.state?.data?.[0].badgeList.map((badge) => (
            <div key={badge.quizId} className={classes.badge}>
              <BadgeCard data={badge} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BadgeList;
